import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SimpleReactValidator from "simple-react-validator";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import BudgetMasterTable from "./BudgetMasterTable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import { clientAccess } from "../../utils/index";
import DatePicker from "react-datepicker";
import moment from "moment";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class BudgetMaster extends React.Component {
  state = {
    LandlordGroups: [],
    clientList: [],
    assetlist: [],
    utilities: [{ from: 1, to: 2, rate: 12 }],
    products: [],
    isOpen: false,
    popupContent: "",
    messsagePopup: false,
    delete: false,
    redirect: false,
    isSearchable: true,
    isClearable: true,
    isDisabled: this.props.match.params.id !== undefined ? true : false,
    url: `${apiUrl.apiUrl.url}/budget/create`,
    id: undefined,
    subAssetNameValues: [],
    tower: [],
    initialValues: {
      assetName: "",
      assetId: "",
      leasedArea: "",
      totalArea: "",
      vacantArea: "",
      dataList: { keys: [], value: { list: [] } },
      budgetingOn: "",
      budgetFrequency: "",
      vacantArea: "",
      budgetType: "",
    },
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/budget/get-all-products`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          products: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/asset/fetch-all-assets`,
    }).then(function (response) {
      console.log(response.data, "asset list");
      self.setState({
        assetlist: response.data,
      });
    });
  }

  changeProduct = (newValue, values) => {
    values.productId = "";
    values.productName = "";
    this.state.initialValues.productId = newValue.value;
    this.state.initialValues.productName = newValue.label;
    values.productId = newValue.value;
    this.setState({});
    console.groupEnd();
  };

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/budget/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this item",
        });
      } else {
        self.setState({
          delete: true,
        });
      }
    });
  }

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;

      var self = this;
      axios({
        method: "get",
        url: `${apiUrl.apiUrl.url}/budget/fetch-all-assets?id=` + newValue.value,
      }).then(function (response) {
        console.log(response.data, "asset list")
        self.setState({
          assetlist: response.data
        });

      });

    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
    console.log(this.groupId, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  leaseDateFormat = (dt) => {
    return dt;
  };

  addRatesRow = (ind) => {
    if (this.state.utilities === undefined) {
      this.state.utilities = [];
    }

    this.state.initialValues.dataList.value[ind].list.push({ month: "" });

    this.setState({});
  };

  removeRatesRow(element, ind) {
    //this.state.utilities.splice(element, 1);
    this.state.initialValues.dataList.value[element].list.splice(ind, 1);
    this.setState({});
  }

  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/budget/create`,
          initialValues: {
            assetName: "",
            assetId: "",
            leasedArea: "",
            totalArea: "",
            vacantArea: "",
            dataList: { keys: [], value: { list: [] } },
            budgetingOn: "",
            budgetFrequency: "",
            vacantArea: "",
            budgetType: "",
            subAssetName: "",
            tower: "",
          },
        });
      } else {
        
        let athis = this;
        axios.get(`${apiUrl.apiUrl.url}/budget/fetch-logic?id=${this.props.match.params.id}`).then((response) => {
          let data = response.data;
          athis.setState({
            url: `${apiUrl.apiUrl.url}/budget/update?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            clientList: data.clientList,
            LandlordGroups: data.LandlordGroups,
            subAssetNameValues: data.subAssets,
            tower: data.towers,
          });
        }).catch((error) => {});

        // fetch(
        //   `${apiUrl.apiUrl.url}/budget/fetch-logic?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/budget/update?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       clientList: data.clientList,
        //       LandlordGroups: data.LandlordGroups,
        //       subAssetNameValues: data.subAssets,
        //       tower: data.towers,
        //     });
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }

  changeAsset = (e) => {
    let assetId = e.value;
    this.state.initialValues.assetName = e.label;
    this.state.initialValues.assetId = e.value;

    //fetch(`${apiUrl.apiUrl.url}/sub-assets/asset-sub-assets/` + assetId,{headers})
    fetch(`${apiUrl.apiUrl.url}/asset/asset-sub-assets?id=` + assetId, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //let assetFromApi = Object.keys(data);

        this.setState({
          subAssetNameValues: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeSubAsset = (e) => {
    let subAssetId = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/asset/sub-asset-towers?id=` + subAssetId, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.state.initialValues.subAssetName = e.target.value;
        this.setState({
          tower: data,
        });
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getTowerDetails = (e) => {
    let towerId = e.target.value;
    let self = this;
    fetch(`${apiUrl.apiUrl.url}/asset/fetch-tower-details?id=` + towerId, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.data.leasedArea, "===", data.data.totalArea, "291");
        self.state.initialValues.tower = towerId;
        self.state.initialValues.leasedArea = data.data.leasedArea;
        self.state.initialValues.totalArea = data.data.totalArea;
        self.state.initialValues.vacantArea =
          data.data.totalArea - data.data.leasedArea;
        self.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
    this.setState({});
  };

  handleChangeAssetName = (e) => {
    this.state.initialValues.assetName = e.label;
    this.state.initialValues.assetId = e.value;
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/asset/fetch-asset-details?id=${e.value}`,
    }).then(function (response) {
      console.log(response.data, "response data");
      self.state.initialValues.leasedArea = response.data.leased_area;
      self.state.initialValues.totalArea = response.data.total_area;
      self.state.initialValues.vacantArea =
        response.data.total_area - response.data.leased_area;
      self.setState({});
    });

    this.setState({});
  };

  setMonth = (index, monthInd, date) => {
    this.state.initialValues.dataList.value[index].list[monthInd]["month"] =
      moment(date).format("MMM YYYY");
    this.setState({});
  };

  changeBudgetingOn = (e) => {
    var self = this;
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/budget/check-details?id=${this.state.initialValues.tower}&unit=${e.target.value}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: response.data.msg,
        });
      } else {
        if (ths.state.initialValues.tower != "" && e.target.value == "unit") {
          axios({
            method: "get",
            url: `${apiUrl.apiUrl.url}/asset/fetch-asset-units?id=${ths.state.initialValues.tower}`,
          }).then(function (response) {
            self.state.initialValues.dataList = response.data;
            self.setState({});
          });
          self.setState({});
        } else {
          self.state.initialValues.dataList = {
            keys: [0],
            value: { 0: { name: "", list: [{ month: "" }] } },
          };
          self.setState({});
        }
      }
    });
  };

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/budget/delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",
        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        assetName: "",
        assetId: "",
        leasedArea: "",
        totalArea: "",
        vacantArea: "",
        dataList: { keys: [], value: { list: [] } },
        budgetingOn: "",
        budgetFrequency: "",
        vacantArea: "",
        budgetType: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      isDisabled: this.props.match.params.id !== undefined ? true : false,
      popupContent: "",
      initialValues: {
        assetName: "",
        assetId: "",
        leasedArea: "",
        totalArea: "",
        vacantArea: "",
        dataList: { keys: [], value: { list: [] } },
        budgetingOn: "",
        budgetFrequency: "",
        vacantArea: "",
        budgetType: "",
      },
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/budget" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/brand-directory">Budget Master</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="#">Budget Master</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            console.log(this.validator.allValid(), "validation");
            if (!this.validator.allValid()) {
              this.validator.showMessages();
              return false;
            }
            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: this.state.initialValues,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!",
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>

              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">
                      {clientAccess() && (
                        <>
                          <div className="newGridSectionInner">
                            <label>
                              Client Group <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="clientGroup"
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(e, "change_client_group");
                                }}
                                value={{
                                  label: this.state.initialValues.groupName,
                                  value: this.state.initialValues.groupId,
                                }}
                                options={this.state.LandlordGroups.map((item) => ({
                                  label: item.group_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="clientGroup"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                          <div className="newGridSectionInner">
                            <label>
                              Client Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="clientName"
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(e, "change_client_name");
                                }}
                                value={{
                                  label: this.state.initialValues.clientName,
                                  value: this.state.initialValues.clientId,
                                }}
                                options={this.state.clientList.map((item) => ({
                                  label: item.client_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="clientName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </>
                      )}
                      <div className="newGridSectionInner">
                        <label>
                          Asset Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            onChange={(e) => {
                              this.changeAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetlist.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          {this.validator.message(
                            "Asset Name",
                            this.state.initialValues.assetId,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Sub Asset Name <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="subAssetName"
                            onChange={(e) => {
                              this.changeSubAsset(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.subAssetNameValues.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.sub_asset_name}
                              </option>
                            ))}
                          </Field>
                          {this.validator.message(
                            "Sub Asset",
                            this.state.initialValues.subAssetName,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="subAssetName"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Tower <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="tower"
                            onChange={(e) => {
                              this.getTowerDetails(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            {this.state.tower.map((obj) => (
                              <option key={obj.id} value={obj.id}>
                                {obj.tower_name}
                              </option>
                            ))}
                          </Field>
                          {this.validator.message(
                            "Tower",
                            this.state.initialValues.tower,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="tower"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="budgetType"
                            onChange={(e) => {
                              this.state.initialValues.budgetType = e.target.value;
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="lease" label="Lease" />
                            <option value="sale" label="Sale" />
                          </Field>
                          {this.validator.message(
                            "Budget Type",
                            this.state.initialValues.budgetType,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="budgetType"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Budgeting On <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="budgetingOn"
                            disabled={this.props.match.params.id !== undefined}
                            onChange={(e) => {
                              this.state.initialValues.budgetingOn = e.target.value;
                              this.changeBudgetingOn(e);
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="unit" label="Unit" />
                            <option value="area" label="Area" />
                          </Field>
                          {this.validator.message(
                            "Budgeting On",
                            this.state.initialValues.budgetingOn,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="budgetingOn"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Total Area <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="totalArea"
                            readOnly="readonly"
                            value={this.state.initialValues.totalArea}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          {this.validator.message(
                            "Total Area",
                            this.state.initialValues.totalArea,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="totalArea"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Leased Area <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            readOnly="readonly"
                            name="leasedArea"
                            value={this.state.initialValues.leasedArea}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          {this.validator.message(
                            "Leased Area",
                            this.state.initialValues.leasedArea,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="leasedArea"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Vacant Area <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            type="text"
                            name="vacantArea"
                            value={this.state.initialValues.vacantArea}
                            onChange={(e) => {
                              this.state.initialValues.vacantArea = e.target.value;
                              this.setState({});
                              handleChange(e);
                            }}
                          />
                          {this.validator.message(
                            "Vacant Area",
                            this.state.initialValues.vacantArea,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="vacantArea"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="newGridSectionInner">
                        <label>
                          Budget Frequency <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="budgetFrequency"
                            value={this.state.initialValues.budgetFrequency}
                            onChange={(e) => {
                              this.state.initialValues.budgetFrequency = e.target.value;
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="monthly" label="Monthly" />
                            <option value="Quarterly" label="Quarterly" />
                            <option value="semi-annually" label="Semi-Annually" />
                            <option value="Annualy" label="Annualy" />
                          </Field>
                          {this.validator.message(
                            "Frequency",
                            this.state.initialValues.budgetFrequency,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="budgetFrequency"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>
                      <div className="gridColOneByThree textWithHrTag">
                        <hr className="m-0 mt-1" />
                        <h4>{this.state.initialValues.budgetingOn.toUpperCase()}</h4>
                        <table className="masterTable w-100">
                          <thead>
                            {this.state.initialValues.budgetingOn == "unit" &&
                              <tr>
                                <th>
                                  Unit <span>*</span>
                                </th>
                                <th>GLA (per sqft)</th>
                                <th>Carpet (per sqft)</th>
                                <th>Month</th>
                                <th>Action</th>
                              </tr>
                            }

                            {this.state.initialValues.budgetingOn == "area" &&
                              <tr>
                                <th>Total Vacant Area</th>
                                <th>Area Budgeted</th>
                                <th>Month</th>
                                <th>Action</th>
                              </tr>
                            }
                          </thead>
                          <tbody>
                            {this.state.initialValues.dataList !== undefined &&
                              this.state.initialValues.dataList.keys.map(function (
                                name,
                                index
                              ) {
                                return (
                                  <>

                                    {this.state.initialValues.dataList.value[
                                      name
                                    ].list.map(function (name1, index1) {
                                      return (
                                        <tr>
                                          {this.state.initialValues
                                            .budgetingOn == "unit" && (
                                              <>
                                                <td>
                                                  {
                                                    this.state.initialValues
                                                      .dataList.value[name]["name"]
                                                  }
                                                </td>
                                                <td>
                                                  {
                                                    this.state.initialValues
                                                      .dataList.value[name]["gla"]
                                                  }
                                                </td>
                                                <td>{
                                                  this.state.initialValues
                                                    .dataList.value[name]["carpet"]
                                                }</td>
                                              </>
                                            )}

                                          {this.state.initialValues
                                            .budgetingOn == "area" && (
                                              <>
                                                <td>
                                                  <Field
                                                    type="text"
                                                    // value={
                                                    //   this.state.initialValues
                                                    //     .dataList.value[name]
                                                    //     .list[index1]["totalArea"]
                                                    // }
                                                    value={this.state.initialValues.vacantArea}
                                                    onChange={(e) => {
                                                      this.state.initialValues.dataList.value[
                                                        name
                                                      ].list[index1][
                                                        "totalArea"
                                                      ] = e.target.value;
                                                      // this.state.initialValues.utilityLogic.rates[
                                                      //   index
                                                      // ].from = e.target.value;
                                                      handleChange(e);
                                                      this.setState({});
                                                    }}
                                                  // value={
                                                  //   this.state.initialValues
                                                  //     .utilityLogic.rates[index].from
                                                  // }
                                                  />
                                                </td>
                                                <td>
                                                  <Field
                                                    type="text"
                                                    //name={`utilityLogic.rates.${index}.to`}
                                                    value={
                                                      this.state.initialValues
                                                        .dataList.value[name]
                                                        .list[index1][
                                                      "budgetedArea"
                                                      ]
                                                    }
                                                    onChange={(e) => {
                                                      this.state.initialValues.dataList.value[
                                                        name
                                                      ].list[index1][
                                                        "budgetedArea"
                                                      ] = e.target.value;
                                                      // this.state.initialValues.utilityLogic.rates[
                                                      //   index
                                                      // ].to = e.target.value;
                                                      this.setState({});
                                                      handleChange(e);
                                                    }}
                                                    // value={
                                                    //   this.state.initialValues
                                                    //     .utilityLogic.rates[index].to
                                                    // }
                                                    onBlur={(e) => { }}
                                                  />
                                                </td>

                                              </>
                                            )
                                          }

                                          <td>
                                            <DatePicker
                                              onChange={
                                                (date) =>
                                                  this.setMonth(
                                                    name,
                                                    index1,
                                                    date
                                                  )
                                                //this.setState({ financialYearOne: date })
                                              }
                                              value={
                                                this.state.initialValues.dataList
                                                  .value[name].list[index1][
                                                "month"
                                                ]
                                              }
                                              onBlur={this.handleCalenderOnBlur}
                                              dateFormat="MMMM yyyy"
                                              showMonthYearPicker
                                              placeholderText="Month Year"
                                            />
                                          </td>

                                          <td>
                                            <span
                                              className="ratesAdd me-2"
                                              onClick={(e) => {
                                                this.addRatesRow(name);
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faPlus} />
                                            </span>
                                            <span
                                              className="ratesRemove"
                                              onClick={(e) => {
                                                this.removeRatesRow(name, index1);
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faTimes} />
                                            </span>
                                          </td>
                                        </tr>
                                      );
                                    }, this)}

                                  </>
                                );
                              },
                                this)}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}>
                          Delete
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          <Link to="/masters/budget">
                            Reset
                          </Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="add_button" disabled={isSubmitting}>
                          Add
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>


              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      {clientAccess() && (
                        <>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Client Group <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Select
                                    className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                    name="clientGroup"
                                    //onInputChange={this.handleChange}
                                    onChange={(e) => {
                                      this.handleChangeLandlordGroup(
                                        e,
                                        "change_client_group"
                                      );
                                    }}
                                    value={{
                                      label: this.state.initialValues.groupName,
                                      value: this.state.initialValues.groupId,
                                    }}
                                    options={this.state.LandlordGroups.map(
                                      (item) => ({
                                        label: item.group_name,
                                        value: item.id,
                                      })
                                    )}
                                  />

                                  <ErrorMessage
                                    name="clientGroup"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Client Name <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Select
                                    className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                    name="clientName"
                                    onChange={(e) => {
                                      this.handleChangeLandlordGroup(
                                        e,
                                        "change_client_name"
                                      );
                                    }}
                                    value={{
                                      label: this.state.initialValues.clientName,
                                      value: this.state.initialValues.clientId,
                                    }}
                                    options={this.state.clientList.map(
                                      (item) => ({
                                        label: item.client_name,
                                        value: item.id,
                                      })
                                    )}
                                  />
                                  <ErrorMessage
                                    name="clientName"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Asset Name <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="assetId"
                                onChange={(e) => {
                                  this.changeAsset(e);
                                  // this.handleChangeAssetName(
                                  //   e
                                  // );
                                  //handleChange(e);
                                }}
                                value={{
                                  label: this.state.initialValues.assetName,
                                  value: this.state.initialValues.assetId,
                                }}
                                options={this.state.assetlist.map((item) => ({
                                  label: item.asset_name,
                                  value: item.id,
                                }))}
                              />
                              {this.validator.message(
                                "Asset Name",
                                this.state.initialValues.assetId,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Sub Asset Name
                              <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="subAssetName"
                                onChange={(e) => {
                                  this.changeSubAsset(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.subAssetNameValues.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.sub_asset_name}
                                  </option>
                                ))}
                              </Field>
                              {this.validator.message(
                                "Sub Asset",
                                this.state.initialValues.subAssetName,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="subAssetName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Tower <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="tower"
                                onChange={(e) => {
                                  this.getTowerDetails(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {this.state.tower.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.tower_name}
                                  </option>
                                ))}
                              </Field>
                              {this.validator.message(
                                "Tower",
                                this.state.initialValues.tower,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="tower"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Type <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="budgetType"
                                //value={this.state.initialValues.budgetType}
                                onChange={(e) => {
                                  this.state.initialValues.budgetType =
                                    e.target.value;
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option value="lease" label="Lease" />
                                <option value="sale" label="Sale" />
                              </Field>
                              {this.validator.message(
                                "Budget Type",
                                this.state.initialValues.budgetType,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="budgetType"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Budgeting On <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="budgetingOn"
                                disabled={
                                  this.props.match.params.id !== undefined
                                    ? true
                                    : false
                                }
                                //value={this.state.initialValues.budgetingOn}
                                onChange={(e) => {
                                  //this.setState({ budgetingOn: e.target.value });
                                  this.state.initialValues.budgetingOn =
                                    e.target.value;
                                  this.changeBudgetingOn(e);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option value="unit" label="Unit" />
                                <option value="area" label="Area" />
                              </Field>
                              {this.validator.message(
                                "Budgeting On",
                                this.state.initialValues.budgetingOn,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="budgetingOn"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Total Area <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="totalArea"
                                readonly="readonly"
                                value={this.state.initialValues.totalArea}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              />
                              {this.validator.message(
                                "Total Area",
                                this.state.initialValues.totalArea,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="totalArea"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Leased Area <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                readonly="readonly"
                                name="leasedArea"
                                value={this.state.initialValues.leasedArea}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              />
                              {this.validator.message(
                                "Leased Area",
                                this.state.initialValues.leasedArea,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="leasedArea"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Vacant Area <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                type="text"
                                name="vacantArea"
                                value={this.state.initialValues.vacantArea}
                                onChange={(e) => {
                                  this.state.initialValues.vacantArea =
                                    e.target.value;
                                  this.setState({});
                                  handleChange(e);
                                }}
                              />
                              {this.validator.message(
                                "Vacant Area",
                                this.state.initialValues.vacantArea,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="vacantArea"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Budget Frequency <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="budgetFrequency"
                                value={this.state.initialValues.budgetFrequency}
                                onChange={(e) => {
                                  // this.setState({ companyType: e.target.value });
                                  this.state.initialValues.budgetFrequency =
                                    e.target.value;
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option value="monthly" label="Monthly" />
                                <option value="Quarterly" label="Quarterly" />
                                <option
                                  value="semi-annually"
                                  label="Semi-Annually"
                                />
                                <option value="Annualy" label="Annualy" />
                              </Field>
                              {this.validator.message(
                                "Frequency",
                                this.state.initialValues.budgetFrequency,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="budgetFrequency"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <h1>{this.state.initialValues.budgetingOn.toUpperCase()}</h1>
                      <table className="masterTable">
                        <thead>
                          {this.state.initialValues.budgetingOn == "unit" &&
                            <tr>
                              <th>
                                Unit <span>*</span>
                              </th>
                              <th>GLA (per sqft)</th>
                              <th>Carpet (per sqft)</th>
                              <th>Month</th>
                              <th>Action</th>
                            </tr>
                          }

                          {this.state.initialValues.budgetingOn == "area" &&
                            <tr>
                              <th>Total Vacant Area</th>
                              <th>Area Budgeted</th>
                              <th>Month</th>
                              <th>Action</th>
                            </tr>
                          }
                        </thead>
                        <tbody>
                          {this.state.initialValues.dataList !== undefined &&
                            this.state.initialValues.dataList.keys.map(function (
                              name,
                              index
                            ) {
                              return (
                                <>

                                  {this.state.initialValues.dataList.value[
                                    name
                                  ].list.map(function (name1, index1) {
                                    return (
                                      <tr>
                                        {this.state.initialValues
                                          .budgetingOn == "unit" && (
                                            <>
                                              <td>
                                                {
                                                  this.state.initialValues
                                                    .dataList.value[name]["name"]
                                                }
                                              </td>
                                              <td>
                                                {
                                                  this.state.initialValues
                                                    .dataList.value[name]["gla"]
                                                }
                                              </td>
                                              <td>{
                                                this.state.initialValues
                                                  .dataList.value[name]["carpet"]
                                              }</td>
                                            </>
                                          )}

                                        {this.state.initialValues
                                          .budgetingOn == "area" && (
                                            <>
                                              <td>
                                                <Field
                                                  type="text"
                                                  // value={
                                                  //   this.state.initialValues
                                                  //     .dataList.value[name]
                                                  //     .list[index1]["totalArea"]
                                                  // }
                                                  value={this.state.initialValues.vacantArea}
                                                  onChange={(e) => {
                                                    this.state.initialValues.dataList.value[
                                                      name
                                                    ].list[index1][
                                                      "totalArea"
                                                    ] = e.target.value;
                                                    // this.state.initialValues.utilityLogic.rates[
                                                    //   index
                                                    // ].from = e.target.value;
                                                    handleChange(e);
                                                    this.setState({});
                                                  }}
                                                // value={
                                                //   this.state.initialValues
                                                //     .utilityLogic.rates[index].from
                                                // }
                                                />
                                              </td>
                                              <td>
                                                <Field
                                                  type="text"
                                                  //name={`utilityLogic.rates.${index}.to`}
                                                  value={
                                                    this.state.initialValues
                                                      .dataList.value[name]
                                                      .list[index1][
                                                    "budgetedArea"
                                                    ]
                                                  }
                                                  onChange={(e) => {
                                                    this.state.initialValues.dataList.value[
                                                      name
                                                    ].list[index1][
                                                      "budgetedArea"
                                                    ] = e.target.value;
                                                    // this.state.initialValues.utilityLogic.rates[
                                                    //   index
                                                    // ].to = e.target.value;
                                                    this.setState({});
                                                    handleChange(e);
                                                  }}
                                                  // value={
                                                  //   this.state.initialValues
                                                  //     .utilityLogic.rates[index].to
                                                  // }
                                                  onBlur={(e) => { }}
                                                />
                                              </td>

                                            </>
                                          )
                                        }

                                        <td>
                                          <DatePicker
                                            onChange={
                                              (date) =>
                                                this.setMonth(
                                                  name,
                                                  index1,
                                                  date
                                                )
                                              //this.setState({ financialYearOne: date })
                                            }
                                            value={
                                              this.state.initialValues.dataList
                                                .value[name].list[index1][
                                              "month"
                                              ]
                                            }
                                            onBlur={this.handleCalenderOnBlur}
                                            dateFormat="MMMM yyyy"
                                            showMonthYearPicker
                                            placeholderText="Month Year"
                                          />
                                        </td>

                                        <td>
                                          <span
                                            className="ratesAdd me-2"
                                            onClick={(e) => {
                                              this.addRatesRow(name);
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faPlus} />
                                          </span>
                                          <span
                                            className="ratesRemove"
                                            onClick={(e) => {
                                              this.removeRatesRow(name, index1);
                                            }}
                                          >
                                            <FontAwesomeIcon icon={faTimes} />
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  }, this)}

                                </>
                              );
                            },
                              this)}
                        </tbody>
                      </table>



                      {false && this.state.initialValues.dataList !== undefined &&
                        this.state.initialValues.dataList.keys.map(function (
                          name,
                          index
                        ) {
                          return (
                            <div className="col-lg-12 mx-auto">
                              {this.state.initialValues.dataList.value[
                                name
                              ].list.map(function (name1, index1) {
                                return (
                                  <>
                                    <div className="row justify-content-center">
                                      {this.state.initialValues.dataList.value[name]}
                                      {this.state.initialValues.budgetingOn ==
                                        "unit" && (
                                          <div className="col-lg-3">
                                            <div className="inputContainer col-lg-12 col-md-12">
                                              <div className="row mb-3">
                                                <label className="col-sm-4 col-form-label">
                                                  Unit{" "}
                                                  <span className="astrik">*</span>
                                                </label>
                                                <div className="col-sm-7">
                                                  {
                                                    this.state.initialValues
                                                      .dataList.value[name]["name"]
                                                  }
                                                  {index1}

                                                  {this.state.initialValues.dataList.value[index].name}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                      {this.state.initialValues.budgetingOn !==
                                        "unit" && (
                                          <>
                                            <div className="col-lg-2">
                                              <div className="inputContainer col-lg-12 col-md-12">
                                                <div className="row mb-3">
                                                  <label className="col-sm-2 col-form-label">
                                                    Total Area
                                                  </label>
                                                  <div className="col-sm-10">
                                                    <Field
                                                      type="text"
                                                      value={
                                                        this.state.initialValues
                                                          .dataList.value[name]
                                                          .list[index1]["totalArea"]
                                                      }
                                                      onChange={(e) => {
                                                        this.state.initialValues.dataList.value[
                                                          name
                                                        ].list[index1][
                                                          "totalArea"
                                                        ] = e.target.value;
                                                        // this.state.initialValues.utilityLogic.rates[
                                                        //   index
                                                        // ].from = e.target.value;
                                                        handleChange(e);
                                                        this.setState({});
                                                      }}
                                                    // value={
                                                    //   this.state.initialValues
                                                    //     .utilityLogic.rates[index].from
                                                    // }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-lg-3">
                                              <div className="inputContainer col-lg-12 col-md-12">
                                                <div className="row mb-3">
                                                  <label className="col-sm-2 col-form-label">
                                                    Area Budgeted
                                                  </label>
                                                  <div className="col-sm-10">
                                                    <Field
                                                      type="text"
                                                      //name={`utilityLogic.rates.${index}.to`}
                                                      value={
                                                        this.state.initialValues
                                                          .dataList.value[name]
                                                          .list[index1][
                                                        "budgetedArea"
                                                        ]
                                                      }
                                                      onChange={(e) => {
                                                        this.state.initialValues.dataList.value[
                                                          name
                                                        ].list[index1][
                                                          "budgetedArea"
                                                        ] = e.target.value;
                                                        // this.state.initialValues.utilityLogic.rates[
                                                        //   index
                                                        // ].to = e.target.value;
                                                        this.setState({});
                                                        handleChange(e);
                                                      }}
                                                      // value={
                                                      //   this.state.initialValues
                                                      //     .utilityLogic.rates[index].to
                                                      // }
                                                      onBlur={(e) => { }}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      <div className="col-lg-2">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label">
                                              Month
                                            </label>
                                            <div className="col-sm-10">
                                              <DatePicker
                                                onChange={
                                                  (date) =>
                                                    this.setMonth(
                                                      name,
                                                      index1,
                                                      date
                                                    )
                                                  //this.setState({ financialYearOne: date })
                                                }
                                                value={
                                                  this.state.initialValues
                                                    .dataList.value[name].list[
                                                  index1
                                                  ]["month"]
                                                }
                                                onBlur={this.handleCalenderOnBlur}
                                                dateFormat="MMMM yyyy"
                                                showMonthYearPicker
                                                placeholderText="Month Year"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-2">
                                        <span
                                          className="ratesAdd me-2"
                                          onClick={(e) => {
                                            this.addRatesRow(name);
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faPlus} />
                                        </span>
                                        <span
                                          className="ratesRemove"
                                          onClick={(e) => {
                                            this.removeRatesRow(name, index1);
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faTimes} />
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                );
                              }, this)}
                            </div>
                          );
                        },
                          this)}
                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.checkDelete(e);
                                }}
                              >
                                Delete
                              </button>
                              <button
                                type="reset"
                                onClick={this.redirectAfterEdit}
                              >
                                <Link to="/masters/budget">
                                  Reset
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Add
                              </button>
                              <button
                                type="reset"
                                onClick={this.redirectAfterEdit}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <BudgetMasterTable />
      </>
    );
  }
}

export default withRouter(BudgetMaster);
